import { Button, Link } from "@chakra-ui/react";
import { FaRegCalendarAlt, FaWhatsapp } from "react-icons/fa";
// import { Link as RouterLink } from "react-router-dom";

export const FilledButton = ({
  title,
  url,
  size = "lg",
  color = "white",
  bgGradient = "linear-gradient(to bottom, #008793, #00A9A5)",
  icon = <FaRegCalendarAlt />,
  backgroundColor,
  ...props
}) => {
  return (
    <Link
      href={url}
      _hover={{ textDecoration: "none" }}
      w={{ base: "full", md: "fit-content" }}
    >
      <Button
        w="fit-content"
        backgroundColor={backgroundColor}
        bgGradient={backgroundColor ? "none" : bgGradient}
        borderRadius="xl"
        boxShadow="rgba(102, 178, 178, 0.2) 0 -25px 18px -14px inset, rgba(102, 178, 178, 0.15) 0 1px 2px, rgba(102, 178, 178, 0.15) 0 2px 4px, rgba(102, 178, 178, 0.15) 0 4px 8px, rgba(102, 178, 178, 0.15) 0 8px 16px, rgba(102, 178, 178, 0.15) 0 16px 32px"
        color={color} // Set text color to white for contrast with blue background
        cursor="pointer"
        fontFamily="CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif"
        padding="7px 20px"
        fontSize={size}
        _focus={{ outline: "none" }}
        _hover={{
          boxShadow:
            "rgba(102, 178, 178, 0.35) 0 -25px 18px -14px inset, rgba(102, 178, 178, 0.25) 0 1px 2px, rgba(102, 178, 178, 0.25) 0 2px 4px, rgba(102, 178, 178, 0.25) 0 4px 8px, rgba(102, 178, 178, 0.25) 0 8px 16px, rgba(102, 178, 178, 0.25) 0 16px 32px",
          transform: "scale(1.05)",
        }}
        {...props}
      >
        {icon} {title}
      </Button>
    </Link>
  );
};

export const OutlineButton = ({ title, url, size = "lg", ...props }) => {
  return (
    <Link href={url} _hover={{ textDecoration: "none" }}>
      <Button
        w="fit-content"
        variant="outline"
        borderColor="#0043b7"
        color="#0043b7"
        borderRadius="xl"
        boxShadow="rgba(0, 67, 183, .15) 0 1px 2px, rgba(0, 67, 183, .15) 0 2px 4px, rgba(0, 67, 183, .15) 0 4px 8px, rgba(0, 67, 183, .15) 0 8px 16px, rgba(0, 67, 183, .15) 0 16px 32px"
        cursor="pointer"
        fontFamily="CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif"
        padding="7px 20px"
        fontSize={size}
        _focus={{ outline: "none" }}
        _hover={{
          borderColor: "#0043b7",
          color: "#0043b7",
          boxShadow:
            "rgba(138, 158, 241, .35) 0 -25px 18px -14px inset, rgba(138, 158, 241, .25) 0 1px 2px, rgba(138, 158, 241, .25) 0 2px 4px, rgba(138, 158, 241, .25) 0 4px 8px, rgba(138, 158, 241, .25) 0 8px 16px, rgba(138, 158, 241, .25) 0 16px 32px",
          transform: "scale(1.05)",
        }}
        {...props}
      >
        {title}
      </Button>
    </Link>
  );
};

export const SimpleOutlineButton = ({ title, url, size = "lg", ...props }) => {
  return (
    <Link href={url} _hover={{ textDecoration: "none" }}>
      <Button
        w="fit-content"
        variant="outline"
        borderColor={{ base: "#008080", _dark: "#b3c0f8" }}
        padding={"0px 14px"}
        color={{ base: "#008080", _dark: "#b3c0f8" }}
        borderRadius="xl"
        fontWeight="semibold"
        fontSize={size}
        _focus={{ outline: "none" }}
        _hover={{
          borderColor: { base: "#008080", _dark: "#b3c0f8" },
          color: { base: "#008080", _dark: "#b3c0f8" },
          boxShadow:
            "rgba(138, 158, 241, .15) 0 2px 4px, rgba(138, 158, 241, .15) 0 4px 8px, rgba(138, 158, 241, .15) 0 6px 12px",
          transform: "scale(1.01)",
        }}
        {...props}
      >
        {title}
      </Button>
    </Link>
  );
};

export const GreenFilledButton = ({
  title,
  url,
  size = "lg",
  backgroundColor = "#77d6a2",
  icon = <FaWhatsapp />,
  ...props
}) => {
  return (
    <Link href={url} _hover={{ textDecoration: "none" }}>
      <Button
        w="fit-content"
        // backgroundColor={backgroundColor} // Greenish shade
        bgGradient="linear-gradient(to bottom, #007A3D, #00A65A);"
        borderRadius="xl"
        boxShadow="rgba(46, 204, 113, .2) 0 -25px 18px -14px inset, rgba(46, 204, 113, .15) 0 1px 2px, rgba(46, 204, 113, .15) 0 2px 4px, rgba(46, 204, 113, .15) 0 4px 8px, rgba(46, 204, 113, .15) 0 8px 16px, rgba(46, 204, 113, .15) 0 16px 32px"
        color="white" // Set text color to white for contrast with green background
        cursor="pointer"
        fontFamily="CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif"
        padding="7px 20px"
        fontSize={size}
        _focus={{ outline: "none" }}
        _hover={{
          boxShadow:
            "rgba(46, 204, 113, .35) 0 -25px 18px -14px inset, rgba(46, 204, 113, .25) 0 1px 2px, rgba(46, 204, 113, .25) 0 2px 4px, rgba(46, 204, 113, .25) 0 4px 8px, rgba(46, 204, 113, .25) 0 8px 16px, rgba(46, 204, 113, .25) 0 16px 32px",
          transform: "scale(1.05)",
        }}
        {...props}
      >
        {icon}
        {title}
      </Button>
    </Link>
  );
};
